import getInlineStyles from './getInlineStyles.js';
import getTypographyStyles from './getTypographyStyles.js';
import getBackgroundStyles from './getBackgroundStyles.js';
import getTextStyles from './getTextStyles.js';
import getBorderStyles from './getBorderStyles.js';
import getLayoutStyles from './getLayoutStyles.js';
export function getStyles(theme, block) {
    var _a;
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, getInlineStyles((_a = block === null || block === void 0 ? void 0 : block.attributes) !== null && _a !== void 0 ? _a : {})), getTypographyStyles(theme, block)), getBackgroundStyles(theme, block)), getTextStyles(theme, block)), getBorderStyles(theme, block)), getLayoutStyles(theme, block));
}
